exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".giveaway_box .giveaway_name[data-v-9f7ab4ee]{font-weight:600;font-size:18px;color:#282828}.txt_box[data-v-9f7ab4ee]{font-size:14px;color:#282828}.btn_box[data-v-9f7ab4ee]{width:172px;height:52px;background:#4d8aff;border-radius:4px;font-weight:600;font-size:16px;color:#fff}.scale_box[data-v-9f7ab4ee]{width:800px;height:40px;background:#fafafa;border:1px solid #dcdfe6;position:relative}.scale_box>img[data-v-9f7ab4ee]{position:absolute;right:10px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}", ""]);

// exports
